/*
 * @Descripttion:常用工具类
 */
import dayjs from 'dayjs';

type StrOrNum = string | number

/**
 * @description: 利用dayjs格式化时间
 * @param {Date} time 时间
 * @param {string} format 格式 YYYY-MM-DD HH:mm:ss
 * @return {*}
 */
export const formatDate = (time: Date | string | number, format = 'YYYY-MM-DD HH:mm:ss') => dayjs(time).format(format);

// 获取n秒前/后的时间

export const getPrevOrNextDate = (time: Date | string | number, type: 'prev' | 'next' = 'next', range = 30) => {
  const nowTime = new Date(time).getTime();
  return type === 'prev'
    ? formatDate(new Date(nowTime - range * 1000))
    : formatDate(new Date(nowTime + range * 1000));
};

// 过去的24小时
export const getPrevHours = () => {
  const now = new Date();
  const nowH = now.getHours();

  const arr = [{ label: '现在', value: formatDate(now) }];
  for (let i = 0; i < 23; i++) {
    const d:any = new Date().setHours(nowH - i);
    let label;
    if (nowH - i > 0) {
      label = `${nowH - i}:00`;
    } else {
      label = `${nowH - i + 24}:00`;
    }
    arr.unshift({ label, value: `${formatDate(d, 'YYYY-MM-DD')} ${label}:00` });
  }
  console.log(arr);
  for (let i = 1; i < 4; i++) {
    const d:any = new Date().setHours(nowH + i);
    let label;
    if (nowH + i < 24) {
      label = `${nowH + i}:00`;
    } else {
      label = `${nowH + i - 24}:00`;
    }
    arr.push({ label, value: `${formatDate(d, 'YYYY-MM-DD')} ${label}:00` });
  }
  return arr;
};

/**
 * @description: 判断传入内容是否是 undefined、null或者空字符串
 * @param {array} str
 */
export const isEmpty = (...str: Array<any>): boolean => str.some((i) => i === undefined || i === null || i === '');

/**
 * @description: 复制
 * @param {*} copyInfo
 */
export const copyHandle = (copyInfo: string): void => {
  const $textarea = document.createElement('textarea');
  $textarea.value = copyInfo;
  document.body.appendChild($textarea);
  $textarea.select();
  document.execCommand('Copy'); // 执行浏览器复制命令
  $textarea.style.display = 'none';
  document.body.removeChild($textarea);
};

/**
 * @description: 通过图片获取网速
 * @param {*} fileSize 单位KB
 * @return B/ms
 */
export const getSpeedWithImg = (imgUrl: string, fileSize: number): any => new Promise((resolve) => {
  const start = Date.now();
  let end = null;
  const img = document.createElement('img');
  img.onload = () => {
    end = Date.now();
    const speed = (fileSize * 1000) / (end - start);
    resolve(speed);
  };
  img.src = imgUrl;
}).catch((err) => { throw err; });

/**
 * @description: 获取两个日期之间的所有日期
 * @param {Date} startTime GMT日期格式
 * @param {Date} endTime GMT日期格式
 */
export const getAllDateCN = (startTime: Date, endTime: Date) => {
  const dateAll = [];
  let i = 0;
  while (endTime.getTime() - startTime.getTime() >= 0) {
    // 获取日期和时间
    const year = startTime.getFullYear();
    const month = startTime.getMonth() + 1;
    const day = startTime.getDate();
    const time = startTime.toLocaleTimeString();

    const fullMonth = month < 10 ? `0${month}` : month;
    const fullDay = day < 10 ? `0${day}` : day;
    dateAll[i] = `${year}-${fullMonth}-${fullDay} ${time}`;

    // 天数+1
    startTime.setDate(startTime.getDate() + 1);
    i += 1;
  }
  return dateAll;
};

/**
 * @description: 求两个数组的交集
 * @param {StrOrNum} arrayFirst
 * @param {StrOrNum} arraySecond
 */
export const intersection = (arrayFirst: StrOrNum[], arraySecond: StrOrNum[]) => {
  const matched = arrayFirst.filter((af: string | number) => arraySecond.some((as: string | number) => af === as));
  return matched;
};

/**
 * @description: 该方法根据属性的类型将对象的属性值重置为其初始值
 * @param {any} obj
 * @return {*}
 */
export const resetObjectValues = (obj: TypeObject) => {
  for (const [prop, value] of Object.entries(obj)) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      switch (typeof value) {
        case 'object':
          resetObjectValues(value);
          break;
        case 'number':
          obj[prop] = 0;
          break;
        case 'boolean':
          obj[prop] = false;
          break;
        case 'string':
          obj[prop] = '';
          break;
        case 'undefined':
        case 'function':
        case 'symbol':
          break;
        default:
          if (Array.isArray(value)) {
            obj[prop] = [];
          }
      }
    }
  }
};

/**
 * @description: 格式化参数，去掉参数字段中的不合规的值
 * @param {*} _paramsObj 参数
 * @return {*}
 */
export function formatParams(_paramsObj: any) {
  if (Object.prototype.toString.call(_paramsObj) === '[object Object]') {
    const params: any = {};
    for (const key in _paramsObj) {
      if (Object.prototype.hasOwnProperty.call(_paramsObj, key)) {
        const item = _paramsObj[key];
        if (item instanceof Array) {
          if (item.length) {
            params[key] = item;
          }
        } else if (typeof item !== 'undefined' && typeof item !== 'function' && item !== null && item !== '') {
          params[key] = item;
        }
      }
    }
    return params;
  }
  return _paramsObj;
}

/**
 * @description: 将标准时间转换为时间戳
 * @param {type}
 * @return:
 */
export function changeDateToTimestamp(dateStr: string) {
  if (dateStr) {
    const dateTime = dateStr.replace(/-/g, '/');
    return Date.parse(dateTime);
  }
  return '';
}

/**
 * @description: 获取数据类型
 * @param {any} obj
 * @return {*}
 */
export function getType(obj: any): any {
  const toString: any = Object.prototype.toString;
  const map: any = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object',
  };
  return map[toString.call(obj)];
}

/**
 * @description: 深克隆
 * @param {T} sourceData
 * @return {*}
 */
export function deepClone(sourceData: any): any {
  const type = getType(sourceData);
  let resultData: any;
  if (type === 'array') {
    resultData = [];
    for (let i = 0; i < sourceData.length; i++) {
      resultData.push(deepClone(sourceData[i]));
    }
  } else if (type === 'object') { // 递归遍历一个object类型数据
    resultData = {};
    for (const i in sourceData) {
      if (Object.prototype.hasOwnProperty.call(sourceData, i)) {
        resultData[i] = deepClone(sourceData[i]);
      }
    }
  } else {
    return sourceData;
  }
  return resultData;
}

/**
 * 数字处理
 * 大于10亿，单位切换为亿
 * 大于10万，单位切换为万
 */
export function computedNumber(num: number | null | undefined, fixedLength = 1): string | number {
  if (num === null || num === undefined) {
    return '-';
  }
  const absNum = Math.abs(num);
  if (absNum / 1000000000 > 1) {
    return `${+((num / 100000000).toFixed(fixedLength))}亿`;
  } if (absNum / 100000 > 1) {
    return `${+((num / 10000).toFixed(fixedLength))}万`;
  }
  return +(num.toFixed(fixedLength));
}

export function computedNumAndUnit(value: number | null | undefined, unit: string, fixedLength = 1) {
  const showValue = computedNumber(value, fixedLength);

  if (showValue !== '-' && +showValue !== showValue) {
    return {
      value: `${showValue}`.slice(0, -1),
      unit: `${`${showValue}`.slice(-1)}${unit}`,
    };
  }

  return {
    value: showValue,
    unit,
  };
}

// 数字千分位格式化
export const formattedNumber = (num: number) => new Intl.NumberFormat(
  'en-US', { maximumFractionDigits: 2 }
).format(num);

// 数字千分位格式化 - 保留一位小数
export const formattedNumberToFixed = (num: number, fixed = 1) => {
  if (Number(num)) {
    return formattedNumber(+Number(num).toFixed(fixed));
  }

  return formattedNumber(num);
};

/**
 * @description: 将扁平数组数据转换为树形结构数据
 * @param {*} data 元数据
 * @param {*} id
 * @param {*} pid
 */
export const arrayToTreeData = (data: TypeObject[], id = 'id', pid = 'parentId') => {
  if (!data.length) { return []; }
  const res = [];
  const temp: TypeObject = {};
  for (let i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i];
  }
  for (let k = 0; k < data.length; k++) {
    data[k]._projectCard = data[k].sourceCode
      ? data[k].sourceCode.split('/')[data[k].sourceCode.split('/').length - 1]
      : null; // 冗余代码：处理项目树时，解析出其对应的身份证id，方便第三方系统跳转至此默认选中项目使用

    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]].children) {
        temp[data[k][pid]].children = [];
      }
      if (!temp[data[k][pid]]._level) {
        temp[data[k][pid]]._level = 1;
      }
      data[k]._level = temp[data[k][pid]]._level + 1;
      temp[data[k][pid]].children.push(data[k]);
    } else {
      res.push(data[k]);
    }
  }
  return res;
};

/**
 * @description: 将树形结构数据转换为扁平数组数据
 * @param {TypeObject} tree
 * @return {*}
 */
export const treeDataToArray = <T = TypeObject>(tree: T[], props = { children: 'children' }) => {
  let res: T[] = [];
  for (const item of tree) {
    const { [props.children]: children, ...i } = (item as any);
    if (children && children.length) {
      res = res.concat(treeDataToArray(children));
    }
    res.push(i);
  }
  return res;
};

/**
 * @description: 获取树形结构数据的所有叶子节点
 * @param {TypeObject} tree
 * @return {*}
 */
export const getLeafs = <T = TypeObject>(treeData: T[], props = { children: 'children' }) => {
  if (!treeData || treeData.length === 0) {
    return [];
  }
  const leafs: T[] = [];
  const recursion = (data: T[]) => {
    data.forEach((item) => {
      if ((item as any)[props.children] && (item as any)[props.children].length > 0) {
        recursion((item as any)[props.children]);
      } else {
        leafs.push(item);
      }
    });
  };
  recursion(treeData);
  return leafs;
};

/**
 * @description: 根据指定的key对数组中对象去重
 */
export const toDeduplicate = (list: TypeObject[], key: string) => {
  const obj: TypeObject = {};
  return list.reduce((cur, next) => {
    if (!obj[next[key]]) {
      obj[next[key]] = true;
      cur.push(next);
    }
    return cur;
  }, []);
};

/**
 * @description: 函数防抖
 */
export const debounce = (func: Func, time: number, immediate = false) => {
  let timer: number | null = null;
  return (...args: any) => {
    if (timer) {
      clearInterval(timer);
    }
    if (immediate) {
      if (!timer) {
        // eslint-disable-next-line no-invalid-this
        func.apply(this, args);
      }
      timer = window.setTimeout(() => {
        timer = null;
      }, time);
    } else {
      timer = window.setTimeout(() => {
        // eslint-disable-next-line no-invalid-this
        func.apply(this, args);
      }, time);
    }
  };
};

/**
 * @description: 函数节流
 */
export const throttle = (func: Func, time: number, immediate = false) => {
  if (immediate) {
    let prevTime = 0;
    return (...args: any) => {
      const nowTime = Date.now();
      if (nowTime - prevTime >= time) {
        // eslint-disable-next-line no-invalid-this
        func.apply(this, args);
        prevTime = nowTime;
      }
    };
  }
  let timer: number | null = null;
  return (...args: any) => {
    if (!timer) {
      // eslint-disable-next-line no-invalid-this
      func.apply(this, args);
      timer = window.setTimeout(() => {
        if (timer) { clearInterval(timer); }
        timer = null;
      }, time);
    }
  };
};

/**
 * @description: 解析URL参数
 * @param {string} url
 * @param {*} string
 * @return {*}
 */
export const parseUrlParams = (url: string): Record<string, string | string[]> => {
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  const parsedParams: Record<string, string | string[]> = {};

  for (const [key, value] of params.entries()) {
    // 如果值是逗号分隔的字符串，将其转换为数组
    parsedParams[key] = value.includes(',')
      ? value.split(',').map((v) => v.trim())
      : value;
  }

  return parsedParams;
};

/**
 * @description: 将一个对象转换为URL查询参数字符串
 * @param {Record} obj
 * @param {*} any
 * @param {*} encodeKeys
 * @param {*} encodeValues
 * @return {*}
 */
export const objectToUrlParams = (obj: Record<string, any>, encodeKeys = true, encodeValues = true): string => {
  const searchParams = new URLSearchParams();

  for (const key in obj) {
    if (obj.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      const encodedKey = encodeKeys ? encodeURIComponent(key) : key;
      const encodedValue = encodeValues ? encodeURIComponent(value) : value;
      searchParams.append(encodedKey, encodedValue);
    }
  }
  return searchParams.toString();
};

/**
 * @description: 根据后端返回的退出登录地址，解析出前端应该跳转的地址
 * @param {string} url 后端返回的登录页面地址
 */
export const getLogoutUrl = (url: string) => {
  const origin = url.split('?')[0];
  const searchParamsObj = parseUrlParams(url);
  if (import.meta.env.VITE_APP_NODE_ENV === 'dev') {
    searchParamsObj.service = 'https://qd-c4-yunjing-web.h5-uat.longfor.com/';
  }

  const urlParams = objectToUrlParams(searchParamsObj, false, false);

  return `${origin}?${urlParams}`;
};

/**
 * @description: 从树形结构数据中，根据id获取指定的节点
 */
export const findNodeByKey = (data: TypeObject[], matched: any, key = 'id'): any => {
  for (const item of data) {
    if (item[key] === matched) {
      return item;
    }

    if (item.children) {
      const node = findNodeByKey(item.children, matched, key);
      if (node) {
        return node;
      }
    }
  }
  return null;
};

/**
 * @description: 去掉树形结构数据中不符合条件的内容
 * @param {TypeObject[]} tree 元数据
 * @param {(node: TypeObject) => boolean} condition 条件 需要传入一个函数
 * @return {*}
 */
export const filterTreeNodes = (
  tree: TypeObject[],
  condition: (node: TypeObject) => boolean
): TypeObject[] => tree.reduce<TypeObject[]>((acc, node) => {
  // 检查当前节点是否符合条件,如果符合条件，则递归处理其子节点
  if (condition(node)) {
    const filteredChildren = filterTreeNodes(node.children || [], condition);
    if (filteredChildren.length > 0) {
      // 只有当过滤后的子节点列表不为空时，才保留子节点
      node.children = filteredChildren;
      acc.push(node);
    } else {
      // 如果没有符合条件的子节点，则只保留当前节点本身
      acc.push({ ...node, children: undefined });
    }
  }
  return acc;
}, []);

/**
 * @description: 检查数组是否为另一个数组的子集
 * @param {array} arrC 要检查的数组元数据
 * @param {array} arrA 被比较的原数组
 * @return {*}
 */
export const isSubsetOf = (arrC: (number | string)[], arrA: (number | string)[]): boolean => {
  const setB = new Set(arrA);

  for (const element of arrC) {
    if (!setB.has(element)) {
      return false;
    }
  }

  return true;
};

/**
 * 树形数据转换(并根据name进行首字母排序)
 *@param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data:any, id = 'id', pid = 'parentId') {
  const res = [];
  const temp = [] as any;
  for (let i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i];
  }
  for (let k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]].children) {
        temp[data[k][pid]].children = [];
      }
      if (!temp[data[k][pid]]._level) {
        temp[data[k][pid]]._level = 1;
      }
      data[k]._level = temp[data[k][pid]]._level + 1;
      temp[data[k][pid]].children.push(data[k]);
      /*
       * temp[data[k][pid]].children.sort((a:any, b:any) => {
       *   if (Object.prototype.hasOwnProperty.call(a, 'workName') && a.workName) {
       *     return a.workName.localeCompare(b.workName);
       *   }
       *   if (Object.prototype.hasOwnProperty.call(a, 'name') && a.name) {
       *     return a.name.localeCompare(b.name);
       *   }
       * });
       */
    } else {
      res.push(data[k]);
    }
  }
  /*
   * console.log(res)
   * return res
   */

  return res;
}
